// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2Pt0-","copyright":"Footer_copyright__2UrJM"};